import { useCallback, useMemo } from 'react';
import { useQuery } from '@apollo/client';
import {
  BookmarkIdsQuery,
  BookmarkIdsQueryVariables
} from '../graphql/graphql';
import { getBookmarkIds } from '../api/queries';

export const useBookmarks = () => {
  const { data } = useQuery<BookmarkIdsQuery, BookmarkIdsQueryVariables>(
    getBookmarkIds
  );
  const bookmarks = data?.bookmarks || [];
  const bookmarkSet = useMemo(
    () => new Set(bookmarks.map(b => b.item.id)),
    [bookmarks]
  );
  const isBookmarked = useCallback(
    (id: string): boolean => bookmarkSet.has(id),
    [bookmarkSet]
  );

  return { bookmarkIds: bookmarks, isBookmarked };
};
